import React, { useState } from "react";
import MenuFrame from "../frames/menu_frame";
import TrayItem from "../frames/tray_item";
import "../dashboard.css";

const EditHome = () => {
  const apps = [
    { name: "Desk Booking", description: "Consignment booking data correction", image: "/img/desk1.png", link: "/correction/desk-booking" },
    { name: "Corporate Booking", description: "Corporate consignment data correction", image: "/img/booking.png", link: "/correction/org-booking" },
    { name: "Pickup", description: "Corporate client consignment pickup data correction", image: "/img/pickup2.png", link: "/pickup-booking" },
    { name: "Packaging", description: "Corporate client consignment packaging data correction", image: "/img/packaging.png", link: "/packaging-booking" },
    { name: "Insurance", description: "Corporate client consignment insurance data correction", image: "/img/insurance.png", link: "/insurance" }
  ]
  const gradients = [
    ["#5B86E5", "#36D1DC"],
    ["#8E2DE2", "#4A00E0"],
    ["#00C9A7", "#92FE9D"],
    ["#FC5C7D", "#6A82FB"],
    ["#FF9966", "#FF5E62"],
    ["#4FACFE", "#00F2FE"],
    ["#43CEA2", "#185A9D"],
    ["#F7971E", "#FFD200"],
  ];
  const [appList, setAppList] = useState(apps);

  const handleSearch = (e) => {
    const txt = e.target.value.trim().toLowerCase();
    if (txt === "") setAppList(apps);
    setAppList(apps.filter((i) => i.description.toLowerCase().includes(txt)));
  }

  return (
    <MenuFrame onSearch={handleSearch}>
      <TrayItem items={appList} gradients={gradients} />
    </MenuFrame>
  );
};

export default EditHome;
